export default __webpack_public_path__ + "static/media/ITRealCase1-moblie-en.31e0e7fb.jpg";